// extracted by mini-css-extract-plugin
module.exports = {"dashboardOnboardingWelcomeContainer":"welcome-modal_dashboardOnboardingWelcomeContainer_35G","dismissText":"welcome-modal_dismissText_1Wx"};